// Generated by Melange

import * as Buhta_cabinet__Btn from "../../../html/Btn.js";
import * as Buhta_cabinet__CalendarDatePickerInput from "../../../molecules/CalendarDatePickerInput.js";
import * as Buhta_cabinet__Checkbox from "../../../html/Checkbox.js";
import * as Buhta_cabinet__DashboardContentTemplate from "../../../../templates/DashboardContentTemplate.js";
import * as Buhta_cabinet__Field from "../../../html/Field.js";
import * as Buhta_cabinet__OrgDashboardHeader from "../../../molecules/OrgDashboardHeader/OrgDashboardHeader.js";
import * as Buhta_cabinet__RadioButton from "../../../html/RadioButton.js";
import * as Buhta_cabinet__Route from "../../../../Route.js";
import * as Buhta_cabinet__Toggle from "../../../atoms/Toggle.js";
import * as Buhta_components__Text from "../../../../../../../packages/components/src/html/Text.js";
import * as Buhta_core__Tenant from "../../../../../../../packages/core/lib/Tenant.js";
import * as Cn from "../../../../../../../vendored/classnames/Cn.js";
import * as Curry from "melange.js/curry.js";
import * as DateTime from "../../../../../../../packages/util/lib/DateTime.js";
import * as MelNumeral from "../../../../../../../packages/util/lib/MelNumeral.js";
import * as StaticAsset from "../../../../../../../packages/util/lib/StaticAsset.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function TaxPaymentsOrdersNewEmployee(Props) {
  let org = Props.org;
  const match = React.useState(function () {
        return "";
      });
  const setBirthday = match[1];
  const match$1 = React.useState(function () {
        return "";
      });
  const setIin = match$1[1];
  const match$2 = React.useState(function () {
        return "";
      });
  const setLastname = match$2[1];
  const match$3 = React.useState(function () {
        return "";
      });
  const setName = match$3[1];
  const match$4 = React.useState(function () {
        return "";
      });
  const setSurname = match$4[1];
  const match$5 = React.useState(function () {
        return "option1";
      });
  const setEmpTypeSelectedOption = match$5[1];
  const empTypeSelectedOption = match$5[0];
  const match$6 = React.useState(function () {
        return "option1";
      });
  const setPaymentTypeOption = match$6[1];
  const paymentTypeOption = match$6[0];
  const match$7 = React.useState(function () {
        return "";
      });
  const setSalary = match$7[1];
  const salary = match$7[0];
  const match$8 = React.useState(function () {
        return false;
      });
  const setIsStandardTaxes = match$8[1];
  const match$9 = React.useState(function () {
        return false;
      });
  const isTaxFree = match$9[0];
  const match$10 = React.useState(function () {
        return false;
      });
  const setIsBenefit = match$10[1];
  const isBenefit = match$10[0];
  const match$11 = React.useState(function () {
        return false;
      });
  const setIsRetired = match$11[1];
  const isRetired = match$11[0];
  const match$12 = React.useState(function () {
        return false;
      });
  const setIsRetiredByYearsServed = match$12[1];
  const isRetiredByYearsServed = match$12[0];
  const match$13 = React.useState(function () {
        return false;
      });
  const setIsDisabled = match$13[1];
  const isDisabled = match$13[0];
  const match$14 = React.useState(function () {
        return false;
      });
  const setIsDisabledIndefinitely = match$14[1];
  const isDisabledIndefinitely = match$14[0];
  const match$15 = React.useState(function () {
        return false;
      });
  const setIsParent = match$15[1];
  const isParent = match$15[0];
  const match$16 = React.useState(function () {
        return false;
      });
  const setIsMother = match$16[1];
  const isMother = match$16[0];
  const match$17 = React.useState(function () {
        return false;
      });
  const setIsStudent = match$17[1];
  const isStudent = match$17[0];
  const match$18 = Buhta_core__Tenant.useTenant(undefined);
  const tenant = match$18[0];
  const contextRoute = function (route) {
    return Buhta_cabinet__Route.contextRoute(tenant.ctx, org.id, route);
  };
  const header = JsxRuntime.jsx(Buhta_cabinet__OrgDashboardHeader.make, {
        title: "Новый сотрудник",
        route: contextRoute({
              TAG: /* Tax */4,
              _0: {
                TAG: /* Payments */0,
                _0: /* Orders */{
                  _0: /* Index */0
                }
              }
            })
      });
  return JsxRuntime.jsxs(Buhta_cabinet__DashboardContentTemplate.make, {
              header: header,
              children: [
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                                    label: "ИИН",
                                    type_: "text",
                                    name: "iin",
                                    size: "m",
                                    required: true,
                                    onChange: (function (value) {
                                        Curry._1(setIin, (function (param) {
                                                return value;
                                              }));
                                      }),
                                    value: match$1[0]
                                  }),
                              JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                                            label: "Фамилия",
                                            type_: "text",
                                            name: "lastname",
                                            size: "m",
                                            required: true,
                                            onChange: (function (value) {
                                                Curry._1(setLastname, (function (param) {
                                                        return value;
                                                      }));
                                              }),
                                            value: match$2[0]
                                          }),
                                      JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                                            label: "Имя",
                                            type_: "text",
                                            name: "name",
                                            size: "m",
                                            required: true,
                                            onChange: (function (value) {
                                                Curry._1(setName, (function (param) {
                                                        return value;
                                                      }));
                                              }),
                                            value: match$3[0]
                                          }),
                                      JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                                            label: "Отчество",
                                            type_: "text",
                                            name: "surname",
                                            size: "m",
                                            onChange: (function (value) {
                                                Curry._1(setSurname, (function (param) {
                                                        return value;
                                                      }));
                                              }),
                                            value: match$4[0]
                                          })
                                    ],
                                    className: "flex gap-4 mt-6"
                                  }),
                              JsxRuntime.jsx("div", {
                                    children: JsxRuntime.jsx(Buhta_cabinet__CalendarDatePickerInput.make, {
                                          value: match[0],
                                          onPicked: (function (date) {
                                              Curry._1(setBirthday, (function (param) {
                                                      return DateTime.toDateFormat(date);
                                                    }));
                                            }),
                                          align: "BottomRight",
                                          className: "w-full",
                                          label: "Дата рождения"
                                        }),
                                    className: "flex gap-4 mt-6"
                                  }),
                              JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
                                    className: "text-default-gray mt-6 font-semibold",
                                    children: "ТИП СОТРУДНИКА"
                                  }),
                              JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsx(Buhta_cabinet__RadioButton.make, {
                                            className: "mt-4",
                                            checked: empTypeSelectedOption === "option1",
                                            onChange: (function (param) {
                                                Curry._1(setEmpTypeSelectedOption, (function (param) {
                                                        return "option1";
                                                      }));
                                              }),
                                            children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                  className: "ml-1",
                                                  children: "Трудовой договор"
                                                })
                                          }),
                                      JsxRuntime.jsx(Buhta_cabinet__RadioButton.make, {
                                            className: "mt-4",
                                            checked: empTypeSelectedOption === "option2",
                                            onChange: (function (param) {
                                                Curry._1(setEmpTypeSelectedOption, (function (param) {
                                                        return "option2";
                                                      }));
                                              }),
                                            children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                  className: "ml-1",
                                                  children: "ГПХ"
                                                })
                                          })
                                    ],
                                    className: "flex gap-6"
                                  }),
                              JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
                                            className: "text-default-gray mt-6 font-semibold",
                                            children: "МЕТОД РАСЧЕТА"
                                          }),
                                      JsxRuntime.jsxs("div", {
                                            children: [
                                              JsxRuntime.jsx(Buhta_cabinet__RadioButton.make, {
                                                    className: "mt-4",
                                                    checked: paymentTypeOption === "option1",
                                                    onChange: (function (param) {
                                                        Curry._1(setPaymentTypeOption, (function (param) {
                                                                return "option1";
                                                              }));
                                                      }),
                                                    children: JsxRuntime.jsxs(Buhta_components__Text.PSmall.make, {
                                                          className: "ml-1",
                                                          children: [
                                                            "От обратного",
                                                            JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
                                                                  className: "text-gray-medium",
                                                                  children: "Зарплата на руки"
                                                                })
                                                          ]
                                                        })
                                                  }),
                                              JsxRuntime.jsx(Buhta_cabinet__RadioButton.make, {
                                                    className: "mt-4",
                                                    checked: paymentTypeOption === "option2",
                                                    onChange: (function (param) {
                                                        Curry._1(setPaymentTypeOption, (function (param) {
                                                                return "option2";
                                                              }));
                                                      }),
                                                    children: JsxRuntime.jsxs(Buhta_components__Text.PSmall.make, {
                                                          className: "ml-1",
                                                          children: [
                                                            "Прямой расчет",
                                                            JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
                                                                  className: "text-gray-medium",
                                                                  children: "Зарплата с налогами"
                                                                })
                                                          ]
                                                        })
                                                  })
                                            ],
                                            className: "flex gap-6"
                                          }),
                                      JsxRuntime.jsxs("div", {
                                            children: [
                                              JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                                                    label: empTypeSelectedOption === "option2" ? "Доход за июнь" : "Зарплата за июнь",
                                                    type_: "text",
                                                    name: "salary",
                                                    size: "m",
                                                    required: true,
                                                    onChange: (function (value) {
                                                        Curry._1(setSalary, (function (param) {
                                                                return value;
                                                              }));
                                                      }),
                                                    value: salary.length !== 0 ? MelNumeral.formatInt({
                                                            NAME: "Str",
                                                            VAL: salary
                                                          }) : ""
                                                  }),
                                              JsxRuntime.jsx("img", {
                                                    className: "absolute right-4 top-4 w-5 h-5",
                                                    alt: "tenge",
                                                    src: StaticAsset.src("/static/icons/tenge.svg")
                                                  })
                                            ],
                                            className: "relative mt-4"
                                          }),
                                      JsxRuntime.jsxs(Buhta_components__Text.Caption.make, {
                                            className: "text-asphalt mt-1",
                                            children: [
                                              "Минимальная сумма — ",
                                              JsxRuntime.jsx("span", {
                                                    children: "85 000 ₸",
                                                    className: "text-links cursor-pointer",
                                                    onClick: (function (param) {
                                                        Curry._1(setSalary, (function (param) {
                                                                return "85000";
                                                              }));
                                                      })
                                                  })
                                            ]
                                          }),
                                      JsxRuntime.jsxs("div", {
                                            children: [
                                              JsxRuntime.jsxs("div", {
                                                    children: [
                                                      JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                            children: "Применить стандартный налоговый вычет"
                                                          }),
                                                      JsxRuntime.jsx("img", {
                                                            className: "w-5 h-5",
                                                            alt: "info",
                                                            src: StaticAsset.src("/static/icons/info.svg")
                                                          })
                                                    ],
                                                    className: "flex gap-2 items-center"
                                                  }),
                                              JsxRuntime.jsx(Buhta_cabinet__Toggle.make, {
                                                    checked: match$8[0],
                                                    onChange: (function (value) {
                                                        Curry._1(setIsStandardTaxes, (function (param) {
                                                                return value;
                                                              }));
                                                      })
                                                  })
                                            ],
                                            className: Cn.$plus("flex justify-between items-center mt-6", Cn.on("hidden", empTypeSelectedOption === "option2"))
                                          })
                                    ]
                                  }),
                              JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsxs("div", {
                                            children: [
                                              JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                    children: "Применить льготы"
                                                  }),
                                              JsxRuntime.jsx("img", {
                                                    className: "w-5 h-5",
                                                    alt: "info",
                                                    src: StaticAsset.src("/static/icons/info.svg")
                                                  })
                                            ],
                                            className: "flex gap-2 items-center"
                                          }),
                                      JsxRuntime.jsx(Buhta_cabinet__Toggle.make, {
                                            checked: isBenefit,
                                            onChange: (function (value) {
                                                Curry._1(setIsBenefit, (function (param) {
                                                        return value;
                                                      }));
                                              })
                                          })
                                    ],
                                    className: "flex justify-between items-center mt-6"
                                  }),
                              JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsx(Buhta_cabinet__Checkbox.make, {
                                            isChecked: isRetired,
                                            onChange: (function (param) {
                                                Curry._1(setIsRetired, (function (param) {
                                                        return !isRetired;
                                                      }));
                                              }),
                                            text: "Пенсионер по возрасту",
                                            subText: "мужчины — 63, женщины — 61"
                                          }),
                                      JsxRuntime.jsxs("div", {
                                            children: [
                                              JsxRuntime.jsx(Buhta_cabinet__Checkbox.make, {
                                                    isChecked: isRetiredByYearsServed,
                                                    onChange: (function (param) {
                                                        Curry._1(setIsRetiredByYearsServed, (function (param) {
                                                                return !isRetiredByYearsServed;
                                                              }));
                                                      }),
                                                    text: "Пенсионер по выслуге лет"
                                                  }),
                                              JsxRuntime.jsx("img", {
                                                    className: "w-5 h-5",
                                                    alt: "info",
                                                    src: StaticAsset.src("/static/icons/info.svg")
                                                  })
                                            ],
                                            className: "flex gap-2 items-center"
                                          }),
                                      JsxRuntime.jsx(Buhta_cabinet__Checkbox.make, {
                                            isChecked: isDisabled,
                                            onChange: (function (param) {
                                                Curry._1(setIsDisabled, (function (param) {
                                                        return !isDisabled;
                                                      }));
                                              }),
                                            text: "Инвалид I, II, III группы"
                                          }),
                                      JsxRuntime.jsx(Buhta_cabinet__Checkbox.make, {
                                            isChecked: isDisabledIndefinitely,
                                            onChange: (function (param) {
                                                Curry._1(setIsDisabledIndefinitely, (function (param) {
                                                        return !isDisabledIndefinitely;
                                                      }));
                                              }),
                                            text: "Инвалид I, II группы бессрочно"
                                          }),
                                      JsxRuntime.jsx(Buhta_cabinet__Checkbox.make, {
                                            isChecked: isParent,
                                            onChange: (function (param) {
                                                Curry._1(setIsParent, (function (param) {
                                                        return !isParent;
                                                      }));
                                              }),
                                            text: "Родитель/опекун инвалида"
                                          }),
                                      JsxRuntime.jsx(Buhta_cabinet__Checkbox.make, {
                                            isChecked: isMother,
                                            onChange: (function (param) {
                                                Curry._1(setIsMother, (function (param) {
                                                        return !isMother;
                                                      }));
                                              }),
                                            text: "Многодетная мать",
                                            subText: "4 и более детей"
                                          }),
                                      JsxRuntime.jsx(Buhta_cabinet__Checkbox.make, {
                                            isChecked: isStudent,
                                            onChange: (function (param) {
                                                Curry._1(setIsStudent, (function (param) {
                                                        return !isStudent;
                                                      }));
                                              }),
                                            text: "Студент"
                                          })
                                    ],
                                    className: Cn.$plus("space-y-4 mt-4", Cn.on("hidden", !isBenefit))
                                  }),
                              JsxRuntime.jsx("hr", {
                                    className: "my-6"
                                  }),
                              JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsxs("div", {
                                            children: [
                                              JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                    className: "text-asphalt-dark",
                                                    children: "Зарплата на руки"
                                                  }),
                                              JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                    children: "100 000 ₸"
                                                  })
                                            ],
                                            className: "flex justify-between"
                                          }),
                                      JsxRuntime.jsxs("div", {
                                            children: [
                                              JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                    className: "text-asphalt-dark",
                                                    children: "Зарплата с налогами"
                                                  }),
                                              JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                    children: "100 000 ₸"
                                                  })
                                            ],
                                            className: "flex justify-between"
                                          }),
                                      JsxRuntime.jsxs("div", {
                                            children: [
                                              JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                    className: "text-asphalt-dark",
                                                    children: "Обязательные пенсионные взносы"
                                                  }),
                                              isTaxFree ? JsxRuntime.jsxs("div", {
                                                      children: [
                                                        JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                              className: "text-success",
                                                              children: "Освобожден"
                                                            }),
                                                        JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                              children: "0 ₸"
                                                            })
                                                      ],
                                                      className: "flex gap-1"
                                                    }) : JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                      children: "8 500 ₸"
                                                    })
                                            ],
                                            className: "flex justify-between mt-3"
                                          }),
                                      JsxRuntime.jsxs("div", {
                                            children: [
                                              JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                    className: "text-asphalt-dark",
                                                    children: "Взносы на соц. мед. страхование"
                                                  }),
                                              isTaxFree ? JsxRuntime.jsxs("div", {
                                                      children: [
                                                        JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                              className: "text-success",
                                                              children: "Освобожден"
                                                            }),
                                                        JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                              children: "0 ₸"
                                                            })
                                                      ],
                                                      className: "flex gap-1"
                                                    }) : JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                      children: "5 955 ₸"
                                                    })
                                            ],
                                            className: "flex justify-between"
                                          }),
                                      JsxRuntime.jsxs("div", {
                                            children: [
                                              JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                    className: "text-asphalt-dark",
                                                    children: "Индивидуальный подоходный налог"
                                                  }),
                                              isTaxFree ? JsxRuntime.jsxs("div", {
                                                      children: [
                                                        JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                              className: "text-success",
                                                              children: "Освобожден"
                                                            }),
                                                        JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                              children: "0 ₸"
                                                            })
                                                      ],
                                                      className: "flex gap-1"
                                                    }) : JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                      children: "5 955 ₸"
                                                    })
                                            ],
                                            className: "flex justify-between"
                                          }),
                                      JsxRuntime.jsxs("div", {
                                            children: [
                                              JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                    className: "text-asphalt-dark",
                                                    children: "Обязательные пенсионные взносы работодателя"
                                                  }),
                                              isTaxFree ? JsxRuntime.jsxs("div", {
                                                      children: [
                                                        JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                              className: "text-success",
                                                              children: "Освобожден"
                                                            }),
                                                        JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                              children: "0 ₸"
                                                            })
                                                      ],
                                                      className: "flex gap-1"
                                                    }) : JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                      children: "1 275 ₸"
                                                    })
                                            ],
                                            className: "flex justify-between"
                                          }),
                                      JsxRuntime.jsxs("div", {
                                            children: [
                                              JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                    className: "text-asphalt-dark",
                                                    children: "Отчисления на соц. мед. страхование"
                                                  }),
                                              isTaxFree ? JsxRuntime.jsxs("div", {
                                                      children: [
                                                        JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                              className: "text-success",
                                                              children: "Освобожден"
                                                            }),
                                                        JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                              children: "0 ₸"
                                                            })
                                                      ],
                                                      className: "flex gap-1"
                                                    }) : JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                      children: "1 275 ₸"
                                                    })
                                            ],
                                            className: Cn.$plus("flex justify-between", Cn.on("hidden", empTypeSelectedOption === "option2"))
                                          }),
                                      JsxRuntime.jsxs("div", {
                                            children: [
                                              JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                    className: "text-asphalt-dark",
                                                    children: "Социальные отчисления"
                                                  }),
                                              isTaxFree ? JsxRuntime.jsxs("div", {
                                                      children: [
                                                        JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                              className: "text-success",
                                                              children: "Освобожден"
                                                            }),
                                                        JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                              children: "0 ₸"
                                                            })
                                                      ],
                                                      className: "flex gap-1"
                                                    }) : JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                      children: "2 975 ₸"
                                                    })
                                            ],
                                            className: Cn.$plus("flex justify-between", Cn.on("hidden", empTypeSelectedOption === "option2"))
                                          }),
                                      JsxRuntime.jsxs("div", {
                                            children: [
                                              JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                    className: "text-asphalt-dark !font-mediumbold",
                                                    children: "Итого за налоги"
                                                  }),
                                              JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                    className: "!font-mediumbold",
                                                    children: "18 700 ₸"
                                                  })
                                            ],
                                            className: "flex justify-between mt-3"
                                          })
                                    ],
                                    className: "flex flex-col gap-1"
                                  })
                            ],
                            className: "p-10"
                          }),
                      className: "bg-white w-[562px] rounded-md"
                    }),
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx(Buhta_cabinet__Btn.make, {
                            title: "Сохранить",
                            className: "px-6 py-3",
                            type_: "submit"
                          }),
                      className: "w-[562px] flex justify-end mt-6"
                    })
              ],
              className: "bg-gray-pale py-10 flex-col items-center"
            });
}

const make = TaxPaymentsOrdersNewEmployee;

export {
  make ,
}
/* Buhta_cabinet__Btn Not a pure module */
